import { StyleSheet } from 'react-native';
import theme from '@/constants/colors';

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.backgroundPrimary || '#fff',
  },
  header: {
    height: 56,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: theme.borderSubtle || '#eee',
    backgroundColor: theme.backgroundPrimary || '#fff',
  },
  backButton: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 18,
    color: theme.textPrimary,
    fontWeight: '600',
  },

  modalContent: {
    paddingHorizontal: 20,
    paddingTop: 24,
    // clears the sticky save footer so the last section (languages) is reachable
    paddingBottom: 120,
  },

  photoSection: {
    alignItems: 'center',
    marginBottom: 18,
  },
  photoContainer: {
    width: 120,
    height: 120,
    borderRadius: 120 / 2,
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.backgroundSecondaryVarient || '#f2f2f2',
  },
  editPhoto: {
    width: 120,
    height: 120,
    borderRadius: 120 / 2,
  },
  initialAvatar: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.backgroundSecondaryVarient || '#f2f2f2',
  },
  initialAvatarText: {
    fontSize: 36,
    color: theme.textPrimary,
    fontWeight: '700',
  },
  cameraOverlay: {
    position: 'absolute',
    right: 6,
    bottom: 6,
    width: 36,
    height: 36,
    borderRadius: 36 / 2,
    backgroundColor: theme.backgroundPrimary,
    alignItems: 'center',
    justifyContent: 'center',
    elevation: 3,
  },
  photoHint: {
    marginTop: 8,
    color: theme.textSecondary,
    fontSize: 13,
  },

  inputSection: {
    marginTop: 12,
  },
  inputLabel: {
    fontSize: 13,
    color: theme.textSecondary,
    marginBottom: 6,
  },
  input: {
    height: 48,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.borderSubtle || '#e6e6e6',
    paddingHorizontal: 14,
    color: theme.textPrimary,
    backgroundColor: theme.backgroundSecondary || '#fff',
  },
  disabledInput: {
    height: 48,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.borderSubtle || '#e6e6e6',
    paddingHorizontal: 14,
    justifyContent: 'center',
    backgroundColor: theme.backgroundSecondary || '#fafafa',
  },
  disabledInputText: {
    color: theme.textSecondary,
  },
  inputHint: {
    marginTop: 6,
    color: theme.textMuted,
    fontSize: 12,
  },

  modalFooter: {
    marginTop: 18,
    alignItems: 'center',
  },
  saveButton: {
    height: 48,
    minWidth: 200,
    paddingHorizontal: 20,
    borderRadius: 12,
    backgroundColor: theme.accentPrimary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  saveButtonDisabled: {
    opacity: 0.6,
  },
  saveButtonText: {
    color: theme.backgroundPrimary,
    fontWeight: '600',
    fontSize: 16,
  },

  /* Family section (design: User Profile Settings.svg) */
  familyCard: {
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 14,
    padding: 16,
    marginTop: 20,
  },
  familyTitle: {
    fontSize: 18,
    color: theme.textPrimary,
    fontWeight: '700',
    marginBottom: 4,
  },
  familySubtitle: {
    fontSize: 13,
    color: theme.textMuted,
    marginBottom: 14,
  },
  inviteRow: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 18,
  },
  inviteInput: {
    flex: 1,
    height: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: theme.borderSubtle,
    paddingHorizontal: 14,
    color: theme.textPrimary,
    backgroundColor: theme.backgroundPrimary,
  },
  inviteButton: {
    height: 44,
    paddingHorizontal: 20,
    borderRadius: 10,
    backgroundColor: theme.accentPrimary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  inviteButtonDisabled: {
    opacity: 0.6,
  },
  inviteButtonText: {
    color: theme.backgroundPrimary,
    fontWeight: '700',
    fontSize: 15,
  },
  sectionHeading: {
    fontSize: 14,
    color: theme.textPrimary,
    fontWeight: '600',
    marginBottom: 8,
  },
  pendingRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    gap: 10,
  },
  pendingEmail: {
    flex: 1,
    color: theme.textPrimary,
    fontSize: 15,
    fontWeight: '600',
  },
  pendingSub: {
    color: theme.textMuted,
    fontSize: 12,
  },
  pendingBadge: {
    backgroundColor: theme.accentPrimary,
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 6,
  },
  pendingBadgeText: {
    color: theme.backgroundPrimary,
    fontSize: 12,
    fontWeight: '600',
  },
  memberRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    gap: 10,
  },
  memberAvatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: theme.backgroundSecondaryVarient,
  },
  memberInfo: {
    flex: 1,
  },
  memberName: {
    color: theme.textPrimary,
    fontSize: 15,
    fontWeight: '600',
  },
  memberRole: {
    color: theme.textMuted,
    fontSize: 12,
  },
  ownerBadge: {
    backgroundColor: theme.accentPrimary,
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 6,
  },
  ownerBadgeText: {
    color: theme.backgroundPrimary,
    fontSize: 12,
    fontWeight: '600',
  },
  familyFooter: {
    marginTop: 14,
    fontSize: 12,
    color: theme.textMuted,
    lineHeight: 18,
  },
  familyEmpty: {
    fontSize: 13,
    color: theme.textMuted,
    marginBottom: 6,
  },
  familyCreateBtn: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    gap: 8,
    alignSelf: 'flex-start' as const,
    backgroundColor: theme.accentPrimary,
    paddingHorizontal: 22,
    paddingVertical: 13,
    borderRadius: 12,
    marginTop: 8,
  },
  familyCreateLink: {
    color: theme.backgroundPrimary,
    fontSize: 15,
    fontWeight: '700',
  },
  modalOverlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.6)' },
  modalOverlaySpacer: { flex: 1 },
  modalCard: { backgroundColor: theme.backgroundSecondary, borderRadius: 16, padding: 16 },
  pollQuestionInput: { marginBottom: 8, minHeight: 42, backgroundColor: theme.backgroundPrimary, borderColor: theme.borderSubtle, borderWidth: 1, borderRadius: 10, paddingHorizontal: 12, color: theme.textPrimary },
  pollOptionInput: { flex: 1, backgroundColor: theme.backgroundPrimary, borderColor: theme.borderSubtle, borderWidth: 1, borderRadius: 10, paddingHorizontal: 12, color: theme.textPrimary },
  pollMeta: { color: theme.textMuted, fontSize: 12 },
  pollAdd: { alignSelf: 'flex-start', paddingVertical: 8 },
  pollAddText: { color: theme.accentPrimary, fontSize: 13 },
  sendButtonFull: { backgroundColor: theme.accentPrimary, borderRadius: 12, paddingVertical: 10, alignItems: 'center' },
  sendButtonFullText: { color: theme.backgroundPrimary, fontWeight: '600' },
  modalTitle: { fontSize: 16, fontWeight: '600', color: theme.textPrimary, marginBottom: 10 },
  suggestionAvatar: { width: 30, height: 30, borderRadius: 15 },
  suggestionAvatarFallback: { alignItems: 'center', justifyContent: 'center', backgroundColor: theme.backgroundPrimary },
  suggestionList: { marginTop: 6, marginBottom: 18, borderRadius: 12, backgroundColor: theme.backgroundSecondary, overflow: 'hidden', width: '100%' },
  suggestionRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 12, paddingVertical: 10, borderTopWidth: 1, borderTopColor: theme.borderSubtle },
  suggestionName: { color: theme.textPrimary, fontSize: 14, flex: 1, marginLeft: 10 },
  suggestionTag: { color: theme.accentPrimary, fontSize: 12, marginLeft: 8 },
  tailTagCopy: { color: theme.accentPrimary, fontSize: 11, marginLeft: 'auto' },
  stickyFooter: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    paddingHorizontal: 16,
    paddingTop: 10,
    backgroundColor: theme.backgroundPrimary,
    borderTopWidth: 1,
    borderTopColor: theme.borderSubtle,
  },
});